import React from 'react';
import PropTypes from 'prop-types';
// import { InputContainer } from './FormElements.styles';
import { FieldContainer } from './Input.styles';
import { FaAsterisk } from 'react-icons/fa';

const InputTextNested = ({
  title,
  value = '',
  nestedValue,
  upperValue,
  name,
  className = '',
  containerClassName = '',
  detail = '',
  requiredInput = false,
}) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    nestedValue({ ...upperValue, [name]: value });
  };

  return (
    <FieldContainer className={containerClassName}>
      <label className={className}>
        {title} <span className="detail">{detail}</span>
        {requiredInput && (
          <FaAsterisk
            size={12}
            color="var(--orange4)"
            style={{ marginLeft: 4 }}
          />
        )}
      </label>
      <input
        type="text"
        name={name}
        onChange={handleChange}
        value={value}
        required={requiredInput}
        // placeholder={placeholder}
      />
    </FieldContainer>
  );
};

InputTextNested.propTypes = {
  title: PropTypes.string,
  value: PropTypes.string,
  nestedValue: PropTypes.func,
  upperValue: PropTypes.array,
  name: PropTypes.string,
  className: PropTypes.string,
  containerClassName: PropTypes.string,
  detail: PropTypes.string,
  requiredInput: PropTypes.bool,
};

export default InputTextNested;
